import { ToastrService } from 'ngx-toastr';
import { Component, EventEmitter, Input, OnInit, Optional, Output } from '@angular/core';
import { FormGroup, FormControl, Validators, AbstractControl } from '@angular/forms';
import { AuthService, IUser, UserService, GeneralService, TrackingService, EVENTS } from '@clooper/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Router } from '@angular/router';

@Component({
  selector: 'app-change-password-modal',
  templateUrl: './change-password-modal.component.html',
  styleUrls: ['./change-password-modal.component.scss']
})
export class ChangePasswordModalComponent implements OnInit {

  @Output() getEvent = new EventEmitter();
  @Input() loading = false;

  user: IUser;

  form = new FormGroup({
    password: new FormControl('', [Validators.required]),
    new_password: new FormControl('', [Validators.required]),
    confirm_password: new FormControl('', [Validators.required]),
  })

  constructor(
    public bsModalRef: BsModalService,
    private userService: UserService, 
    private toastr: ToastrService,
    private gs: GeneralService,
    @Optional() private authService: AuthService,
    private tracker: TrackingService,
    private router: Router) {}
  get pwdMatch() {
    const { new_password, confirm_password} = this.form.value;
    return new_password === confirm_password;
  }
  getCtrl(f: string): FormControl {
    return (this.form.get(f) as FormControl)
  }

  ngOnInit(): void {
    this.user = this.authService.getAuthorizedUser()
  }

  save() {
    const {confirm_password, ...payload } = this.form.value;
    this.loading = true;
    this.userService.change_password(this.user.id, payload).subscribe((res: any) => {
      this.toastr.success(res.message);
      const data = {route: this.router.url}
      this.tracker.track(EVENTS.EDIT_USER_PASSWORD, data)

      this.bsModalRef.hide();
      }, err => {
        this.toastr.error(this.gs.getErrMsg(err))
      }).add(() => this.loading = false)
  }

}
